import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Button, Form, FormGroup } from 'reactstrap';

import { autoinject, bind, FormStore, inject, Input, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import { AccountStore } from '../Account/AccountStore';
import { AppStore } from '../Core/AppStore';
import { UsersStore } from '../Users/UsersStore';
import { EmailModal } from './EmailModal';
import { ManageStore } from './ManageStore';
import { PasswordModal } from './PasswordModal';
import { PhoneModal } from './PhoneModal';
import { BsTrash } from '@react-icons/all-files/bs/BsTrash';

export interface ICloseAccountProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class CloseAccount extends React.Component<ICloseAccountProps> {
    public render() {
        return (
            <div className="container-fluid px-2 px-md-4">
                <div className="row mb-5">
                    <div className="col-md-8">
                        <div className="container-fluid text-white bg-danger rounded">
                            <div className="row">
                                <div className="d-none d-md-flex col-md-1">
                                    <div className="flex-items-center h-100">
                                        <BsTrash className=" text-white f-20" />
                                    </div>
                                </div>

                                <div className="col-11">
                                    <div>You are about to delete your SmartVu® account.</div>
                                    <div>All of your data will be removed and this can not be reverted.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <Form onSubmit={this.closeAccount}>
                            <FormGroup color={this.deleteForm.fields.password.state}>
                                <label>Password</label>
                                <Input
                                    type="password"
                                    field={this.deleteForm.fields.password}
                                    placeholder="Password"
                                    required
                                />
                            </FormGroup>

                            <FormGroup>
                                <Button type="submit" color="primary" disabled={this.loading}>
                                    {this.loading ? 'Loading' : 'Close Account'}
                                </Button>
                            </FormGroup>
                        </Form>
                    </div>
                </div>

                <Modal
                    className="modal-sm"
                    title="Confirm Deletion"
                    modalHandle={this.confirmModalHandle}
                    btnClass="w-50"
                    footerClass="d-flex justify-content-center"
                >
                    <div className="text-center">Are you sure you want to delete your account?</div>
                </Modal>
            </div>
        );
    }

    @bind
    @action
    private async closeAccount(event: React.MouseEvent<HTMLFormElement>) {
        event.preventDefault();
        this.deleteForm.onSubmit();
        if (this.deleteForm.validate()) {
            if (await this.confirmModalHandle.confirm()) {
                this.loading = true;

                try {
                    await this.accountStore.deleteAsync(this.deleteForm.values);
                    this.deleteForm.clear();
                    this.accountStore!.signoutRedirect();
                } catch (e: any) {
                    if (e.modelState) {
                        this.deleteForm.clearGlobalErrors();
                        this.deleteForm.addErrors(e.modelState);
                    } else {
                        console.error(e);
                    }
                } finally {
                    this.loading = false;
                }
            } else {
                console.log('invalid');
            }
        }
    }

    @observable
    private readonly deleteForm = new FormStore<Mri.Web.Portal.Controllers.Account.DeleteUserModel>({
        password: '',
    });

    @observable
    private loading = false;
    private confirmModalHandle = new ModalHandle();

    @inject
    private accountStore!: AccountStore;
}
